import React, { ReactElement } from 'react';
import { changeLanguage, t } from 'i18next';
import { Locale } from '@oneaudi/avp-hck-dga-customerui-commons';
import styled, { keyframes } from 'styled-components';
import { getI18nLocale } from '../../i18n/i18n';
import spinner from '../../assets/spinner/LOGO_CUPRA.png';

const rotation = keyframes`
  20% {
    transform: rotateY(0deg);
  }
  50% {
    transform: rotateY(180deg);
  }
  70% {
    transform: rotateY(150deg);
  }
  100% {
    transform: rotateY(180deg);
  }
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 5rem;

  h2 {
    margin-top: 2rem;
  }

  img {
    width: 10rem;
    -webkit-animation: ${rotation} 1s ease-in-out infinite;
    animation: ${rotation} 1s ease-in-out infinite;
  }
`;

interface SpinnerProps {
  locale?: Locale;
}

export const Spinner = (props: SpinnerProps): ReactElement => {
  const { locale } = props;

  if (locale) {
    changeLanguage(getI18nLocale(locale));
  }

  return (
    <StyledContainer>
      <img src={spinner} alt="Loading" data-testid="loading-spinner" />
      {locale && <h2 data-testid="loading-title">{t('giveaway.loading.title')}</h2>}
    </StyledContainer>
  );
};
